var Formatter = require('../formatter');

var fakeClient = {
  formatter: function formatter(builder) {
    return new Formatter(fakeClient, builder);
  }
};
module.exports = fakeClient;